module.exports = __webpack_public_path__ + "static/media/addClientIllustartion.1b8812cf.svg";